import { StyleFunctionProps } from '@chakra-ui/theme-tools'

import { outlineFieldStyles } from './shared'

const variants = {
  outline: (props: StyleFunctionProps) => ({
    field: outlineFieldStyles(props),
  }),
}

export default {
  variants,
}
